        uniform bool uHasDiffuseMap;
        uniform sampler2D uDiffuseMap;
        uniform vec3 uColor;
        uniform float uFadeHeight;
        uniform float uTerrainHeight;
        uniform float uBrightness;
        varying vec3 vWorldPosition;
        varying vec2 vUv;

        void main() {
            vec4 colorDiffuse = uHasDiffuseMap ? texture2D(uDiffuseMap, vUv) : vec4(uColor, 1.0);

            float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPosition.y);

            colorDiffuse.rgb *= fadeFactor * uBrightness;

            csm_DiffuseColor = colorDiffuse;
        }